module.exports = __webpack_public_path__ + "static/media/spot2.6abbd84f.png";